import { create } from 'zustand';
import { PRD4010_R01Dto, PRD4010_R01CardData } from './Dto_PRD4010_R01';

export interface PRD4010_R01Filter {
    compCd: string;
    searchDate: Date | undefined;
    autoRefreshInterval: number | null;
}

export const defaultPRD4010_R01Filter: PRD4010_R01Filter = {
    compCd: '',
    searchDate: new Date(),
    /** 제조현장 모니터링: 기본 자동조회 주기(분) */
    autoRefreshInterval: 5,
};

export interface Store_PRD4010_R01 {
    PRD4010_R01Filter: PRD4010_R01Filter;
    setPRD4010_R01Filter: (filter: Partial<PRD4010_R01Filter>) => void;

    PRD4010_R01List: PRD4010_R01Dto[];
    setPRD4010_R01List: (list: PRD4010_R01Dto[]) => void;

    PRD4010_R01CardList: PRD4010_R01CardData[];
    setPRD4010_R01CardList: (list: PRD4010_R01CardData[]) => void;

    initData: () => void;
}

export const usePRD4010_R01Store = create<Store_PRD4010_R01>((set) => ({
    PRD4010_R01Filter: defaultPRD4010_R01Filter,
    setPRD4010_R01Filter: (filter) =>
        set((state) => ({
            PRD4010_R01Filter: { ...state.PRD4010_R01Filter, ...filter },
        })),

    PRD4010_R01List: [],
    setPRD4010_R01List: (list) => set({ PRD4010_R01List: list }),

    PRD4010_R01CardList: [],
    setPRD4010_R01CardList: (list) => set({ PRD4010_R01CardList: list }),

    initData: () =>
        set({
            PRD4010_R01Filter: defaultPRD4010_R01Filter,
            PRD4010_R01List: [],
            PRD4010_R01CardList: [],
        }),
}));
